import Vue from 'vue';
import {
  Button,
  Checkbox,
  Collapse,
  Datepicker,
  Dropdown,
  Field,
  Icon,
  Input,
  Loading,
  Modal,
  Navbar,
  Notification,
  Numberinput,
  Radio,
  Select,
  Skeleton,
  Slider,
  Steps,
  Switch,
  Table,
  Tabs,
  Taginput,
  Tooltip,
  Upload,
  Dialog,
  Snackbar,
  Toast
} from 'buefy';

import { merge } from 'buefy/src/utils/helpers'
import config, { setOptions } from 'buefy/src/utils/config'
import { registerComponentProgrammatic } from 'buefy/src/utils/plugins'
import ConfigComponent from 'buefy/src/utils/ConfigComponent'

export default () => {
  [
    Button,
    Checkbox,
    Collapse,
    Datepicker,
    Dropdown,
    Field,
    Icon,
    Input,
    Loading,
    Modal,
    Navbar,
    Notification,
    Numberinput,
    Radio,
    Select,
    Skeleton,
    Slider,
    Steps,
    Switch,
    Table,
    Tabs,
    Taginput,
    Tooltip,
    Upload,
    Dialog,
    Snackbar,
    Toast
  ].forEach((component) => Vue.use(component));

  setOptions(merge(
    config,
    {
      "css": false,
      "defaultIconPack": "fas",
      "materialDesignIcons": false
},
    true
  ));

  registerComponentProgrammatic(Vue, 'config', ConfigComponent);
};
